import { gql } from '@apollo/client';

export const CAN_DELETE_CUSTOMER = gql`
  query CanDeleteCustomer($fetchEvPayments: Boolean) {
    canDeleteCustomer(fetchEvPayments: $fetchEvPayments)
  }
`;
